import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { buildVideoPlayerInputs } from "@/components/VideoPlayer";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyVideoPlayerInputs = [
  {
    name: "videoId",
    friendlyName: "Reward Video ID",
    type: "string",
    required: true,
  },
  {
    name: "percentageToWatch",
    friendlyName: "Percentage of video to trigger reward",
    regex: {
      pattern: "^[1-9][0-9]?$|^100$",
      options: "g",
      message: "You must use number between 1-100",
    },
    type: "string",
  },
  {
    name: "video",
    type: "object",
    required: true,
    subFields: buildVideoPlayerInputs(),
  },
] as const satisfies Inputs;

export const LoyaltyVideoPlayerComponent: RegisteredComponent = {
  name: "LoyaltyVideoPlayer",
  component: dynamic(async () =>
    withValidation(
      loyaltyVideoPlayerInputs,
      (await import("./LoyaltyVideoPlayer")).LoyaltyVideoPlayer,
      "LoyaltyVideoPlayer"
    )
  ),
  inputs: loyaltyVideoPlayerInputs,
};
